module.exports = __webpack_public_path__ + "static/img/yellow-ballon-thumb.1fb3006.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/yellow-ballon-thumb.jpg
// module id = pPxY
// module chunks = 0